"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RugbyLeagueAdAllocationEvent;
(function (RugbyLeagueAdAllocationEvent) {
    RugbyLeagueAdAllocationEvent["try"] = "try";
    RugbyLeagueAdAllocationEvent["dropGoal"] = "dropGoal";
    RugbyLeagueAdAllocationEvent["conversion"] = "conversion";
    RugbyLeagueAdAllocationEvent["penaltyGoal"] = "penaltyGoal";
})(RugbyLeagueAdAllocationEvent = exports.RugbyLeagueAdAllocationEvent || (exports.RugbyLeagueAdAllocationEvent = {}));
//# sourceMappingURL=adEvents.js.map